export default __webpack_public_path__ + "static/media/profile.c7d0f1f2.jpg";